import { render, staticRenderFns } from "./IconFilePlus.vue?vue&type=template&id=48adc2cd"
import script from "./IconFilePlus.vue?vue&type=script&lang=js"
export * from "./IconFilePlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports